<template>
    <div
        v-separator-link=" universe === null ? 200 : 100"
        style="overflow: auto;"
        :style="{height: `calc(100vh - ${$store.getters.pageHeight}px)`}"
    >
        <div class="page-title">Details</div>
        <div class="universe-details-container gcmcn-card-gradient">
            <div class="edit-row">
                <div class="details-title">Name</div>
                <el-button
                    type="primary"
                    class="gcmcn-primary-btn small"
                    @click="editUniverse"
                >Edit</el-button>
            </div>
            <div>{{ universe.display_name }}</div>
            <div class="details-title some-space">Entity</div>
            <div class="universe-entity">
                <img :src="entity.logo">
                <div>{{ entity.display_name }}</div>
            </div>
            <el-divider></el-divider>
            <gcmcn-filters
                :filter-values="[searchFilter, selectedSortType]"
                @reset-filters="resetFilters"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <template v-if="filteredEvents.length > 0">
                <event-card
                    v-for="event in filteredEvents"
                    :key="event.uid"
                    :event="event"
                ></event-card>
            </template>
            <div v-else class="list-empty">No events</div>
        </div>
    </div>
</template>

<script>
import EventCard from './event.vue';
import { GcmcnFilters, SearchFilter, Dropdown } from 'gcmcn-common';
export default {

    components: {
        EventCard,
        GcmcnFilters,
        SearchFilter,
        Dropdown,
    },

    props: {
        universe: {
            type: Object,
            required: true,
        },
        events: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            searchFilter: '',
            selectedSortType: '',
        };
    },

    computed: {
        entity (){
            return this.$store.getters.entities.find((ent) => ent.uid === this.universe.scopes.entity_uid);
        },

        filteredEvents (){
            let events = this.events.filter((ev) => ev.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            if(this.selectedSortType){
                events.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    events.reverse();
                }
            }
            return events;
        },
    },

    mounted (){

    },

    methods: {
        editUniverse (){
            this.$emit('on-edit');
        },
        resetFilters (){
            this.$refs.search.clear();
            this.selectedSortType = '';
        }
    },
};
</script>

<style lang="scss">
.universe-details-container{
    .some-space{
        margin-top: 15px;
    }
    .universe-entity{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        img{
            width: 80px;
        }
        div{
            font-size: 18px;
            font-weight: bold;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Universes/universe-detail.vue